import { CURRENCY_DATA, MinorUnits } from './CurrencyConstants.js';
import { ValidationError } from './errors/index.js';
export class Currency {
    code;
    name;
    minorUnits;
    constructor(code, name, minorUnits) {
        this.code = code;
        this.name = name;
        this.minorUnits = minorUnits;
    }
    static instances = new Map();
    // Initialize all currency instances from data
    static {
        for (const [code, data] of Object.entries(CURRENCY_DATA)) {
            Currency.instances.set(code, new Currency(code, data.name, MinorUnits[code]));
        }
    }
    /**
     * Get a Currency instance by its code.
     * Use CurrencyCodeSchema.parse() to convert strings to CurrencyCode first.
     */
    static fromCode(code) {
        const instance = Currency.instances.get(code);
        if (!instance) {
            // This should never happen if the type system is sound
            throw new ValidationError(`Invalid currency code: ${code}`);
        }
        return instance;
    }
    /**
     * Get the divisor for converting between major and minor units.
     * Returns a string for currencies with >15 minor units to avoid precision loss
     * (currencies with 16+ decimal places would exceed Number.MAX_SAFE_INTEGER).
     * Returns a number for currencies with <=15 minor units for backward compatibility.
     */
    getMinorUnitDivisor() {
        // For minor units > 15, using 10**n exceeds Number.MAX_SAFE_INTEGER (2^53 - 1)
        // Return a string that Decimal can parse without precision loss
        if (this.minorUnits > 15) {
            return `1${'0'.repeat(this.minorUnits)}`;
        }
        return 10 ** this.minorUnits;
    }
    toString() {
        return this.code;
    }
    equals(other) {
        return this === other; // Reference equality since we have singletons
    }
}
//# sourceMappingURL=Currency.js.map